import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { chainesLocales } from './../include/chainesLocales';
import { getJson } from '../service/serviceUtil';

class SessionTermine extends Component {
    constructor(props) {
        super(props);

        this.state = {langueCourante: 'FR', mounted: false, enquete: this.props.suffixe};
    }

    get labels() {
        return chainesLocales['SessionTermine'][this.state.langueCourante];
    }

    componentDidMount() {
        Promise.all([getJson('collecteLangue', {suffixe: this.state.enquete}), getJson('detruireSession')]).then(([langue, retour]) => {
            if (retour === true) {
                console.info("session detruite");
            } else {
                console.error("Erreur API detruire session");
            }

            this.setState({langueCourante: langue || 'FR', mounted: true});
        }).catch((err) => {
            console.error("Erreur API quitte questionnaire: " + err);

            this.setState({mounted: true});
        });
    }

    render() {
        if (this.state.mounted) {
            return (
                <div dangerouslySetInnerHTML={{ __html: this.labels.text }} />
            );
        } else {
            return (
                <>&nbsp;<div class="loading-spinner-mini" /></>
            );
        }
    }
}

SessionTermine.propTypes = {
    lang: PropTypes.oneOf(['FR', 'AN', 'CR', 'CS']).isRequired
}

SessionTermine.defaultProps = {
    lang: "FR"
}

export default SessionTermine